/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useRef } from "react";
import IconButton from "@mui/material/IconButton";
import Cancel from "@mui/icons-material/Cancel";
import classes from "./css.module.css";
import { connect } from "react-redux";
import actionTypes from "../../store/actions";
import { toast } from "react-hot-toast";
import { CheckCircle, ErrorOutline } from "@mui/icons-material";
import { ClearIcon } from "../icons/icons";
import { Tooltip } from "@mui/material";

const ErrorMsg = (props) => {
  let colorClass = props.warning
    ? classes.outerDivWarningColor
    : props.msgType
      ? classes.outerDivInfoColor
      : classes.outerDivErrColor;

  useEffect(() => {
    if (props.errMsg) {
      if (props.msgType === true) {
        // success/info
        // toast.success(props.errMsg, {
        //     className: 'qa-toast-success',
        //     style: {
        //         border: '1px solid #4F8A10',
        //         padding: '16px',
        //         color: '#4F8A10',
        //       },
        //       iconTheme: {
        //         primary: '#4F8A10',
        //         secondary: '#FFFAEE',
        //       }
        // });
        toast.custom((t) => (
          <div
            className={`qa-toast-success ${
              t.visible ? "animate-enter" : "animate-leave"
            }`}
            style={{
              pointerEvents: "auto",
              border: "1px solid #4F8A10",
              padding: "16px",
              color: "#4F8A10",
              background: "#FFFFFF",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <CheckCircle style={{ color: "#4F8A10" }} />
            <div
              role="status"
              aria-live="polite"
              className="data-testid-success-msg"
              style={{ wordBreak: "break-word" }}
            >
              {props.errMsg}
            </div>
            <Tooltip title="Close">
              <IconButton onClick={() => toast.dismiss(t.id)}>
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </div>
        ));
      } else {
        // error
        // toast.error(props.errMsg || "Something went wrong", {
        //     className: 'qa-toast-error',
        //     style: {
        //         border: '1px solid #D8000C',
        //         padding: '16px',
        //         color: '#D8000C',
        //       },
        //       iconTheme: {
        //         primary: '#D8000C',
        //         secondary: '#FFFAEE',
        //       }
        // });
        toast.custom((t) => (
          <div
            className={`qa-toast-error ${t.visible ? "animate-enter" : "animate-leave"}`}
            style={{
              pointerEvents: "auto",
              border: "1px solid #D8000C",
              padding: "16px",
              color: "#D8000C",
              background: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <ErrorOutline style={{ color: "#D8000C" }} />
            <div
              role="status"
              aria-live="polite"
              className="data-testid-error-msg"
              style={{ wordBreak: "break-word" }}
            >
              {props.errMsg}
            </div>
            <Tooltip title="Close">
              <IconButton
                onClick={() => {
                  toast.dismiss(t.id);
                }}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </div>
        ));
      }

      // clear Redux after showing
      props.setErrorMessage("", null);
    }
  }, [props.errMsg, props.msgType]);

  return null; // no UI render needed

  // Auto-hide the error message after a delay
  //  useEffect(() => {
  //      if (props.errMsg) {
  //          const timer = setTimeout(() => {
  //              props.setErrorMessage("");
  //          }, 10000); // Adjust the delay time (10 seconds)

  //          return () => clearTimeout(timer); // Cleanup timer if component unmounts
  //      }
  //  }, [props.errMsg, props.setErrorMessage]);

  // return (
  //     props.errMsg ?
  //         <div className={['errorOuterDiv ', colorClass].join(" ")}>
  //             <div className={'errorInnerDiv'}>
  //                 <IconButton className={classes.cancelButton} onClick={() => { props.setErrorMessage("") }}>
  //                     <Cancel />
  //                 </IconButton>
  //                 <span>{props.errMsg}</span>
  //             </div>
  //         </div>
  //         :
  //         null
  // )
};

const mapStateToProps = (state) => {
  return {
    errMsg: state.global.errMsg,
    msgType: state.global.msgType,
    warning: state.global.warning,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorMsg);
